import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axiosHttp from "../../services/interceptor";
import { setUserLoggedIn } from "../../store/userInfo/userInfo.slice";
import { useDispatch } from "react-redux";

const CdpAuthPage = () => {
	let [userRoles, setUserRoles] = useState([]);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const initializeUser = async () => {
			sessionStorage.setItem("header-footer", false);
			const _token = searchParams.get("token");
			const wcn = searchParams.get("wcn");

			await handleAccessToken(_token);
			dispatch(setUserLoggedIn(true));
			sessionStorage.setItem("wcn", wcn);
			if (_token) {				
				navigate("/reports");
			}
		};
		initializeUser();
	}, []);

	const handleAccessToken = async (token) => {
		try {
			const res = await axiosHttp({
				url: `api/Accounts/StoreCookie`,
				method: "POST",
				data: { accessToken: token },
			});
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<div className="page-container row">
			<div className="col-md-6">
				<div className="d-flex justify-content-between erp-dashboard">
					<div className="emmision-reporter-heading">CDP</div>
				</div>
			</div>
		</div>
	);
};

export default CdpAuthPage;
